var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(-7412 -2623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_785",
    "data-name": "Ellipse 785",
    transform: "translate(7412 2623)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 21.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M10.922,7.559a5.6,5.6,0,1,0,5.6,5.6A5.592,5.592,0,0,0,10.922,7.559Zm0,9.242a3.641,3.641,0,1,1,3.641-3.641A3.648,3.648,0,0,1,10.922,16.8ZM18.058,7.33a1.306,1.306,0,1,1-1.306-1.306A1.3,1.3,0,0,1,18.058,7.33Zm3.709,1.326A6.465,6.465,0,0,0,20,4.079a6.507,6.507,0,0,0-4.577-1.764c-1.8-.1-7.209-.1-9.013,0a6.5,6.5,0,0,0-4.577,1.76A6.486,6.486,0,0,0,.071,8.651c-.1,1.8-.1,7.209,0,9.013a6.465,6.465,0,0,0,1.764,4.577,6.515,6.515,0,0,0,4.577,1.764c1.8.1,7.209.1,9.013,0A6.465,6.465,0,0,0,20,22.241a6.507,6.507,0,0,0,1.764-4.577c.1-1.8.1-7.2,0-9.008ZM19.437,19.6a3.686,3.686,0,0,1-2.076,2.076c-1.438.57-4.85.439-6.439.439s-5.006.127-6.439-.439A3.686,3.686,0,0,1,2.406,19.6c-.57-1.438-.439-4.85-.439-6.439s-.127-5.006.439-6.439A3.686,3.686,0,0,1,4.483,4.644c1.438-.57,4.85-.439,6.439-.439s5.006-.127,6.439.439a3.686,3.686,0,0,1,2.076,2.076c.57,1.438.439,4.85.439,6.439S20.007,18.166,19.437,19.6Z",
    transform: "translate(7424.156 2633.008)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.a1912724cf876d66f9fbab0fa9f35187.svg";
export { ForwardRef as ReactComponent };